<script setup>
import { ref } from "vue";

const { caption, hint, rows, t } = defineProps({
  caption: {
    type: String,
    required: true,
  },
  hint: {
    type: String,
    required: true,
  },
  rows: {
    type: Array,
    default: () => [],
  },
  t: {
    type: Function,
    required: true,
  },
});

const copiedDetailKey = ref(null);

function fallbackCopy(text) {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "true");
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.select();

  try {
    document.execCommand("copy");
    return true;
  } catch {
    return false;
  } finally {
    document.body.removeChild(ta);
  }
}

async function copyDetailRow(raw, key) {
  const text = (raw || "").trim();
  if (!text) return;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const ok = fallbackCopy(text);
      if (!ok) return;
    }

    copiedDetailKey.value = key;
    window.setTimeout(() => {
      copiedDetailKey.value = null;
    }, 1200);
  } catch {
    // Ignore clipboard errors.
  }
}
</script>

<template>
  <section class="panel desktop-qr-panel krw-bank-panel">
    <div class="panel-head">
      <div>
        <h2 class="panel-title">{{ caption }}</h2>
        <p class="panel-subtitle">{{ hint }}</p>
      </div>
    </div>

    <div
      v-if="rows.length"
      class="manual-list qr-bank-detail-list"
      role="list"
    >
      <div
        v-for="row in rows"
        :key="row.key"
        class="transfer-item"
        role="listitem"
      >
        <div class="transfer-main">
          <p class="transfer-label">{{ row.label }}</p>
          <p class="transfer-value">{{ row.value }}</p>
        </div>
        <div class="transfer-actions">
          <button
            type="button"
            class="btn-copy"
            :class="{ copied: copiedDetailKey === row.key }"
            @click="copyDetailRow(row.rawValue, row.key)"
          >
            {{ copiedDetailKey === row.key ? t("copied") : t("copy") }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
